import { render, staticRenderFns } from "./DisburseTable.vue?vue&type=template&id=66feca5a&scoped=true&slot-scope=scope&"
import script from "./DisburseTable.vue?vue&type=script&lang=js&"
export * from "./DisburseTable.vue?vue&type=script&lang=js&"
import style0 from "./DisburseTable.vue?vue&type=style&index=0&id=66feca5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66feca5a",
  null
  
)

export default component.exports